import React, { createContext, useContext } from 'react'
import { useUser } from '@fs/zion-user'
import { useParams } from '@fs/zion-router'
import { getRouteParameterAtIndex } from '../helpers/url_helper'
import { useGetCategories } from '../hooks/api'
import topics from '../components/topics'

const TopicContext = createContext()
export const useTopicContext = () => useContext(TopicContext)

export default function TopicProvider({ children }) {
  const topicId = getRouteParameterAtIndex(0)
  const user = useUser()
  const { activityGroupId } = useParams()
  const templeShareableAnswerActivities = [
    'temple-experiences',
    'baptisms-for-dead',
    'my-endowment',
    'temple-sealings',
    'my-memorable-temple',
    'my-sealing',
    'ministering-angels',
  ]

  const validTopicId = templeShareableAnswerActivities.includes(activityGroupId)
    ? topics?.temple.id
    : topics?.[topicId]?.id
  const enabled = user?.signedIn && !!validTopicId
  const { data } = useGetCategories(validTopicId, enabled)
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <TopicContext.Provider value={{ categories: data?.items, topicId }}>{children}</TopicContext.Provider>
}
